import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tavahind

  <span style="color:#85c1dc;">**FI:**</span>
  Normaalihinta

  <span style="color:#85c1dc;">**RU:**</span>
  Обычная цена
*/
/* @__NO_SIDE_EFFECTS__ */
const m1833 = msg(
  mf`Tavahind`,
  mf`Normaalihinta`,
  mf`Обычная цена`,
)

export { m1833 as 'w.basket.summary.regular_price' }